import { IsUUID } from 'class-validator'
import { ApiProperty } from '@nestjs/swagger'

/**
 * DTO for manually triggering stats calculation
 */
export class CalculateActivityStatsDto {
  @ApiProperty({
    description: 'UUID de l\'activité',
    example: '550e8400-e29b-41d4-a716-446655440000',
  })
  @IsUUID('4')
  activityId!: string
}

